export type { ImageProps } from "./Image";
export { default } from "./Image";
